export type ItemCategory = 'flight' | 'hotel' | 'dining' | 'activity' | 'transport' | 'treat' | 'coffee' | 'drink' | 'other';

export interface ItineraryItem {
  id: string;
  name: string;
  date?: string;       // 'YYYY-MM-DD'
  time?: string;       // 'HH:MM' 24hr
  category?: ItemCategory;
  link?: string;
  notes?: string;
  location?: string;
  cost?: number;
}

export const CATEGORIES: {
  value: ItemCategory;
  label: string;
  emoji: string;
  bgColor: string;
  textColor: string;
}[] = [
  { value: 'flight',    label: 'Flight',    emoji: '✈️', bgColor: '#dbeafe', textColor: '#1d4ed8' },
  { value: 'hotel',     label: 'Hotel',     emoji: '🏨', bgColor: '#d1fae5', textColor: '#065f46' },
  { value: 'dining',    label: 'Dining',    emoji: '🍽️', bgColor: '#fef3c7', textColor: '#92400e' },
  { value: 'activity',  label: 'Activity',  emoji: '🎭', bgColor: '#ede9fe', textColor: '#6d28d9' },
  { value: 'transport', label: 'Transport', emoji: '🚗', bgColor: '#fce7f3', textColor: '#9d174d' },
  { value: 'treat',     label: 'Treat',     emoji: '🍦', bgColor: '#fff7ed', textColor: '#c2410c' },
  { value: 'coffee',    label: 'Coffee',    emoji: '☕', bgColor: '#fdf4e7', textColor: '#78350f' },
  { value: 'drink',     label: 'Drink',     emoji: '🍹', bgColor: '#ecfdf5', textColor: '#065f46' },
  { value: 'other',     label: 'Other',     emoji: '📍', bgColor: '#f3f4f6', textColor: '#374151' },
];
